/* import __COLOCATED_TEMPLATE__ from './fin-studio-entry-point.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const FinStudioEntryPoint = templateOnlyComponent<Signature>();

export default FinStudioEntryPoint;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAutomation::FinStudioEntryPoint': typeof FinStudioEntryPoint;
  }
}
